/**
 * Sort function alphabetically by name for locations
 * @param {object} a location
 * @param {object} b location
 */
export const locationSortFunc = function(a, b) {
    if (!a.name && !b.name) return 0;
    if (!a.name) return 1;
    if (!b.name) return -1;
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA > nameB) return 1;
    if (nameA < nameB) return -1;
    return 0;
};

/**
 * Sort function alphabetically by name for cabinets.
 * Also makes sure cabinets that are online are given priority in sort.
 * @param {object} a cabinet
 * @param {object} b cabinet
 */
export const cabinetSortFunc = function(a, b) {
    if (!a.name && !b.name) return 0;
    if (!a.name) return 1;
    if (!b.name) return -1;
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    const onlineA = a.isOnline;
    const onlineB = b.isOnline;
    if ((onlineA && onlineB) || (!onlineA && !onlineB)) {
        if (nameA > nameB) return 1;
        if (nameA < nameB) return -1;
        return 0;
    } else if (onlineA) {
        return -1;
    } else {
        return 1;
    }
};

/**
 * Returns true if the given cabinet/device is a freezer.
 * Accepts cabinet objects from either Redux state (cabinet.deviceSubType) or
 * the controlPanel selectedDevice shape (selectedDevice.subType).
 *
 * Recognised freezer subTypes: IF3Freezer (legacy) and the IFZ_* family
 * (e.g. IFZ_3_0_S1_V1_EU, IFZ_3_0_R1S1_V1_EU).
 */
export const isFreezer = (cabinet) => {
    if (!cabinet) return false;
    const subType = cabinet.subType || cabinet.deviceSubType;
    if (!subType) return false;
    return subType === 'IF3Freezer' || subType.startsWith('IFZ_');
};

/**
 * Returns true if the subType indicates a hybrid cabinet (RFID + weight).
 * Pattern: IFG_*_R*S*  (e.g. IFG_3_0_R1S1_V1_EU)
 */
export const isHybridCabinet = (cabinet) => {
    if (!cabinet) return false;
    const subType = cabinet.subType || cabinet.deviceSubType;
    if (!subType || !subType.startsWith('IFG_')) return false;
    return /R\d+S\d+/.test(subType);
};

/**
 * Returns true if the subType indicates a scale-only cabinet (weight, no RFID).
 * Pattern: IFG_*_S* without R  (e.g. IFG_3_0_S1_V1_EU)
 */
export const isScaleCabinet = (cabinet) => {
    if (!cabinet) return false;
    const subType = cabinet.subType || cabinet.deviceSubType;
    if (!subType || !subType.startsWith('IFG_')) return false;
    return !(/R\d+S\d+/.test(subType));
};
